import type { FunctionComponent } from 'react'
import { login } from '../../utils/auth/auth'
import Button, { Variant } from '../Button/Button'

function dropFocus() {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur()
  }
}

const Login: FunctionComponent = () => {
  function handleLogin() {
    login()
  }

  return (
    <Button
      variant={Variant.Menu}
      type="button"
      onClick={() => {
        handleLogin()
        dropFocus()
      }}
      data-testid="headerMenuLinkLogin"
    >
      Inloggen
    </Button>
  )
}

export default Login
